module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl2-75.9844629c.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl2-75.png
// module id = 3548
// module chunks = 11